import clsx from 'clsx';
import { useContext } from 'react';

import { Alter25Button } from '@/components/alter25/Alter25Button';
import { BuyNowIcons } from '@/components/alter25/shared-marketing/BuyNowIcons';
import { ScreenSize } from '@/context/ScreenSizeContext';
import { ShopContext } from '@/context/ShopContext';
import { useIsGreaterThanOrEqual } from '@/hooks/useScreenSize';

interface Alter25FloatingBuyNowProps {
  show: boolean;
  className?: string;
}

export const Alter25FloatingBuyNow: React.FC<Alter25FloatingBuyNowProps> = ({
  show,
  className,
}) => {
  const { cartTotalPrice, cartIsReadyForCheckout, goToCheckout } = useContext(ShopContext);
  const isMdOrGreater = useIsGreaterThanOrEqual(ScreenSize.md);

  return (
    <div className={clsx('', className)}>
      <div
        className={clsx(
          //
          'transition-all duration-300 shadow',
          'bg-white w-full py-3 md:py-4 px-4 text-center',
          {
            'fixed top-0 right-0 z-50': show && isMdOrGreater,
            'fixed bottom-0 right-0 z-50 shadow-invert': show && !isMdOrGreater,
            hidden: !show,
          }
        )}
      >
        <div className="flex justify-center items-center flex-col">
          <Alter25Button
            onClick={goToCheckout}
            text={'Buy Now - ' + cartTotalPrice()}
            size="md"
            full
            className="max-w-[580px] order-last sm:order-none"
            disabled={!cartIsReadyForCheckout}
          ></Alter25Button>

          <BuyNowIcons className="mt-0 sm:mt-2 mb-2 sm:mb-0 w-full sm:w-[580px]" xs />
        </div>
      </div>
    </div>
  );
};
